export default __webpack_public_path__ + "d77a91b7d9b9a4752a8f9beeb917b911.svg";